import React, { Component } from "react";
import { observer } from "mobx-react";

import { CopyCode } from "../../common/CopyCode";
import { Heading3 } from "../../common/Heading3";
import { Popup } from "../../common/Popup";
import * as styles from "./ShareCreated.scss";

export interface IShareCreatedProps {
    visible: boolean;
    url: string;
    teleopUrl?: string;
    onClose: () => void;
}

@observer
export class ShareCreated extends Component<IShareCreatedProps> {
    public render() {
        const { visible, url, teleopUrl, onClose } = this.props;
        return (
            <Popup
                visible={visible}
                onClose={onClose}
                className={styles["share-created"]}
            >
                <Heading3 className={styles.heading}>Share</Heading3>
                <div className={styles.content}>
                    <p>
                        Use the following link to share your <b>device view</b>
                    </p>
                    <CopyCode
                        singleLine={true}
                        className={styles.url}
                        value={url}
                        data-testid="share-data-copy-button"
                    />

                    {teleopUrl && (
                        <>
                            <p>
                                Or use the following link to share your{" "}
                                <b>teleop view</b>:
                            </p>
                            <CopyCode
                                singleLine={true}
                                className={styles.url}
                                value={teleopUrl}
                            />
                        </>
                    )}
                </div>
            </Popup>
        );
    }
}
